import { EditSat } from '@app/plugins/edit-sat/edit-sat';
import { getEl } from '../../engine/utils/get-el';
export class UiValidation {
    static allowedCodes = [
        'Delete',
        'Backspace',
        'Tab',
        'Escape',
        'NumpadEnter',
        'Enter',
        'Period',
        'NumpadDecimal',
        'Home',
        'End',
        'ArrowLeft',
        'ArrowUp',
        'ArrowRight',
        'ArrowDown',
    ];
    static numberCodes = [
        'Numpad1',
        'Numpad2',
        'Numpad3',
        'Numpad4',
        'Numpad5',
        'Numpad6',
        'Numpad7',
        'Numpad8',
        'Numpad9',
        'Numpad0',
        'Digit1',
        'Digit2',
        'Digit3',
        'Digit4',
        'Digit5',
        'Digit6',
        'Digit7',
        'Digit8',
        'Digit9',
        'Digit0',
    ];
    static initUiValidation() {
        /*
         * Note: Depending on which plugins on enabled, some or all of
         * the following event listeners may be added.
         */
        getEl('editSat', true)
            ?.querySelectorAll('input')
            .forEach((el) => {
            if (el.id === `${EditSat.elementPrefix}-country`) {
                return;
            }
            el.addEventListener('keydown', UiValidation.validateNumOnly_);
        });
        getEl(`${EditSat.elementPrefix}-ecen`, true)?.addEventListener('keydown', UiValidation.allowPeriod_);
        getEl(`${EditSat.elementPrefix}-day`, true)?.addEventListener('keyup', UiValidation.esDay366_);
        getEl(`${EditSat.elementPrefix}-inc`, true)?.addEventListener('keyup', UiValidation.esInc180_);
        getEl(`${EditSat.elementPrefix}-rasc`, true)?.addEventListener('keyup', UiValidation.esRasc360_);
        getEl(`${EditSat.elementPrefix}-meanmo`, true)?.addEventListener('keyup', UiValidation.esMeanmo18_);
        getEl(`${EditSat.elementPrefix}-argPe`, true)?.addEventListener('keyup', UiValidation.esArgPe360_);
        getEl(`${EditSat.elementPrefix}-meana`, true)?.addEventListener('keyup', UiValidation.esMeana360_);
        getEl('ms-lat', true)?.addEventListener('keyup', UiValidation.msLat90_);
        getEl('ms-lon', true)?.addEventListener('keyup', UiValidation.msLon180_);
    }
    static allowPeriod_(e) {
        if (e.code === 'Period' || e.code === 'NumpadDecimal') {
            e.preventDefault();
        }
    }
    static esArgPe360_() {
        if (parseInt(getEl(`${EditSat.elementPrefix}-argPe`).value) < 0) {
            getEl(`${EditSat.elementPrefix}-argPe`).value = '000.0000';
        }
        if (parseInt(getEl(`${EditSat.elementPrefix}-argPe`).value) > 360) {
            getEl(`${EditSat.elementPrefix}-argPe`).value = '360.0000';
        }
    }
    static esDay366_() {
        if (parseInt(getEl(`${EditSat.elementPrefix}-day`).value) < 0) {
            getEl(`${EditSat.elementPrefix}-day`).value = '000.00000000';
        }
        if (parseInt(getEl(`${EditSat.elementPrefix}-day`).value) >= 367) {
            getEl(`${EditSat.elementPrefix}-day`).value = '366.00000000';
        }
    }
    static esInc180_() {
        if (parseInt(getEl(`${EditSat.elementPrefix}-inc`).value) < 0) {
            getEl(`${EditSat.elementPrefix}-inc`).value = '000.0000';
        }
        if (parseInt(getEl(`${EditSat.elementPrefix}-inc`).value) > 180) {
            getEl(`${EditSat.elementPrefix}-inc`).value = '180.0000';
        }
    }
    static esMeana360_() {
        if (parseInt(getEl(`${EditSat.elementPrefix}-meana`).value) < 0) {
            getEl(`${EditSat.elementPrefix}-meana`).value = '000.0000';
        }
        if (parseInt(getEl(`${EditSat.elementPrefix}-meana`).value) > 360) {
            getEl(`${EditSat.elementPrefix}-meana`).value = '360.0000';
        }
    }
    static esMeanmo18_() {
        if (parseInt(getEl(`${EditSat.elementPrefix}-meanmo`).value) < 0) {
            getEl(`${EditSat.elementPrefix}-meanmo`).value = '00.00000000';
        }
        if (parseInt(getEl(`${EditSat.elementPrefix}-meanmo`).value) > 18) {
            getEl(`${EditSat.elementPrefix}-meanmo`).value = '18.00000000';
        }
    }
    static esRasc360_() {
        if (parseInt(getEl(`${EditSat.elementPrefix}-rasc`).value) < 0) {
            getEl(`${EditSat.elementPrefix}-rasc`).value = '000.0000';
        }
        if (parseInt(getEl(`${EditSat.elementPrefix}-rasc`).value) > 360) {
            getEl(`${EditSat.elementPrefix}-rasc`).value = '360.0000';
        }
    }
    static msLat90_() {
        if (parseInt(getEl('ms-lat').value) < -90) {
            getEl('ms-lat').value = '-90.000';
        }
        if (parseInt(getEl('ms-lat').value) > 90) {
            getEl('ms-lat').value = '90.000';
        }
    }
    static msLon180_() {
        if (parseInt(getEl('ms-lon').value) < -180) {
            getEl('ms-lon').value = '-180.000';
        }
        if (parseInt(getEl('ms-lon').value) > 180) {
            getEl('ms-lon').value = '180.000';
        }
    }
    static validateNumOnly_(e) {
        /*
         * Allow: Ctrl+A, Command+A
         * Allow: backspace, delete, tab, escape, enter and .
         * Allow: home, end, left, right, down, up
         */
        if ((e.code === 'KeyA' && (e.ctrlKey === true || e.metaKey === true)) || UiValidation.allowedCodes.includes(e.code)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (!UiValidation.numberCodes.includes(e.code)) {
            e.preventDefault();
        }
    }
}
